var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.48125 1.18905L0.5375 1.25639L4.7875 6.27503C4.93125 6.44499 5.14687 6.55082 5.3875 6.55082C5.62812 6.55082 5.84375 6.44179 5.9875 6.27503L10.2344 1.26602L10.3062 1.18264C10.3594 1.10247 10.3906 1.00626 10.3906 0.903647C10.3906 0.624655 10.1594 0.396973 9.87187 0.396973H0.909375C0.621875 0.396973 0.390625 0.624655 0.390625 0.903647C0.390625 1.00947 0.425 1.10888 0.48125 1.18905Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowShow);
export default __webpack_public_path__ + "static/media/arrow-show.df4a6393cc9341c235b6439bcb88c91f.svg";
export { ForwardRef as ReactComponent };